import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs'; 
import { ConfigGeneralDto } from '../models/config-general.dto';
import { AuthService } from './auth.service';
import { environmentIa } from 'src/environments/environment.ia';

export interface LimitesFacturasResponse {
  status: string;
  message: string;
  data?: {
      cantidad_facturas_ingresadas: number;
      limite: number;
  };
  error?: string;
  statusCode?: number;
}

export interface LimiteAlcanzadoResponse {
  message: string;
  data: {
      cantidad_actual: number;
      limite_permitido: number;
      diferencia: number;
  };
}


@Injectable({
  providedIn: 'root'
})
export class ConfigGeneralService {
  private apiUrl = ``;
  private entity = `config-general`;
  private apiUrlIa = environmentIa.production ? `${environmentIa.apiUrlProd}/config-general` : `${environmentIa.apiUrl}/config-general`

  constructor(private http: HttpClient, private authService: AuthService) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
       
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  } 

  getByConfig(config:string): Observable<ConfigGeneralDto[]> {
    return this.http.get<ConfigGeneralDto[]>(`${this.apiUrl}/${config}`);
  }

      /**
     * Verifica los límites de facturas ingresadas
     */
      verificarLimitesFacturas(): Observable<LimitesFacturasResponse | LimiteAlcanzadoResponse> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.authService.getToken()}`);
        return this.http.get<LimitesFacturasResponse>(`${this.apiUrlIa}/verificar/limites`, { headers })
            .pipe(
                catchError(error => {
                    console.error('Error al verificar límites de facturas:', error);
                    // Si es un 400 Bad Request, puede ser que se alcanzó el límite
                    if (error.status === 400 && error.error) {
                        return of(error.error as LimiteAlcanzadoResponse);
                    }
                    throw error;
                })
            );
    }

}
